import { isStandalonePwa } from '@/utils/pwaStandalone';

/** Installations-Wizard nur im Browser; installierte Web-App → nur PIN. */
export const shouldUseKitchenInstallWizard = () => !isStandalonePwa();
